var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['check-box', _vm.cartTheme && 'check-box--cart', _vm.validity && 'check-box--validity']},[_c('div',{staticClass:"check-box__wrapper"},[_c('button',{class:[
        'check-box__selector',
        _vm.showCheck && 'check-box__selector--selected',
        _vm.disabled && 'check-box__selector--disabled' ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClickHandler}})])])}
var staticRenderFns = []

export { render, staticRenderFns }